import Data from '../Data';

// Action Types

export const Invalidate = 'canny/linear_issue_suggestions/invalidate';
export const SuggestionsError = 'canny/linear_issue_suggestions/suggestions_error';
export const SuggestionsLoaded = 'canny/linear_issue_suggestions/suggestions_loaded';

// Actions

function suggestionsLoaded(search, suggestions) {
  return {
    search,
    suggestions,
    timestamp: Date.now(),
    type: SuggestionsLoaded,
  };
}

function suggestionsError(search, error) {
  return {
    error,
    search,
    timestamp: Date.now(),
    type: SuggestionsError,
  };
}

function invalidate() {
  return {
    timestamp: Date.now(),
    type: Invalidate,
  };
}

// Action Creators

function fetchSuggestions(search) {
  return (dispatch, getState) => {
    const cookies = getState().cookies;
    return Data.fetch(
      {
        issues: {
          input: {
            search,
          },
          query: Data.queries.linearIssueSuggestions,
        },
      },
      cookies,
      (error, data) => {
        if (error) {
          return dispatch(suggestionsError(search, error));
        } else {
          return dispatch(suggestionsLoaded(search, data.issues));
        }
      },
    );
  };
}

export function loadSuggestions(search) {
  return (dispatch, getState) => {
    if (shouldFetchSuggestions(getState(), search)) {
      return dispatch(fetchSuggestions(search));
    }

    return Promise.resolve();
  };
}

export function invalidateSuggestions() {
  return (dispatch) => {
    return dispatch(invalidate());
  };
}

// Helpers

function shouldFetchSuggestions(state, search) {
  if (typeof search !== 'string' || search.length === 0) {
    return false;
  }

  const issueSuggestions = state.issueSuggestions;
  return !issueSuggestions[search];
}
